import * as React from "react";

function IconGasStation({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg className="icon icon-tabler icon-tabler-gas-station" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M13 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3" /><line x1={4} y1={19} x2={14} y2={19} /><line x1={5} y1={11} x2={13} y2={11} /><path d="M5 19v-12a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v12" /><path d="M17 7v1a1 1 0 0 0 1 1h1" /></svg>;
}

export default IconGasStation;